export const DEFAULT_CLUSTER_NAME = 'Unassigned';
